import React, { useState } from 'react'
import {
    Box,
    Stack
} from '@mui/material'
import * as Images from '../../components/UIComponents/Images'
import * as Buttons from '../../components/UIComponents/Button'
import * as Texts from '../../components/UIComponents/Text'
import * as Forms from '../../components/UIComponents/Form'
// const { innerWidth } = window

const NurseOnboarding = ({
    onClick,
    headerText,
    descriptionText,
    call2ActionText,
    dict
}) => {
    // console.log("dict ",dict)
    const [userId, updateUserId] = useState("")
    const [password, updatePassword] = useState("")

    return (
        <Stack
            direction="column"
            justifyContent={"space-between"}
            spacing={{
                xs: 2,
                sm: 4,
                md: 8
            }}
            sx={{
                pt: {
                    xs: 4,
                    md: 6
                },
                px: {
                    xs: 2,
                    md: 6
                }
            }}
        >{/* 添加 Logo */}
        <Box
            sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                
            }}
        >
            <Images.Logo
                style={{
                    width: '300px', // 设置 Logo 的宽度
                    height: 'auto' // 保持比例
                }}
            />
        </Box>
            {/*<Box
                sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    height: .4,
                    maxHeight: {
                        sm: 160
                    }
                }}
            >
                <Images.NurseOnboarding />
            </Box>*/}
            <Stack
                direction="column"
                justifyContent={"center"}
                alignItems={"center"}
                spacing={{
                    xs: 3,
                    sm: 4,
                    md: 5
                }}
                sx={{
                    flex: 1,
                    textAlign: 'center',
                    maxWidth: 480
                    // bgcolor: "background.dark"
                }}
            >
                <Texts.H4>{`${headerText} ${process.env.REACT_APP_VERSION}`}</Texts.H4>
                <Texts.Text>{descriptionText}</Texts.Text>
                <Stack
                    spacing={2}
                >
                    <Forms.TextInput
                        type={"text"}
                        label={dict["userId"]}
                        ariaLabel='user_id'
                        icon='envelope'
                        onChange={e => updateUserId(e.target.value)}
                        error=''
                        helperText=''
                        sx={{
                            color: "primary.main",
                            maxWidth: 360,
                            bgcolor: 'background.default'

                        }}
                    >
                    </Forms.TextInput>
                    <Forms.TextInput
                        type={"password"}
                        label={dict["password"]}
                        ariaLabel='user_pass'
                        icon='envelope'
                        onChange={e => updatePassword(e.target.value)}
                        error=''
                        helperText=''
                        sx={{
                            color: "primary.main",
                            maxWidth: 360,
                            bgcolor: 'background.default'

                        }}
                    >
                    </Forms.TextInput>
                </Stack>
                <Buttons.Button
                    onClick={() => onClick(userId, password)}
                >
                    <Texts.H4 sx={{ color: "primary.contrastText" }}>{call2ActionText}</Texts.H4>
                </Buttons.Button>
            </Stack>

            {/*<Box
                sx={{
                    display: 'flex',
                    justifyContent: 'center'
                }}
            >
                <Texts.Paragraph>What is Ms. OICI?</Texts.Paragraph>
            </Box>*/}
        </Stack>
    )
}


export default NurseOnboarding